/*
 * @Author: Roman
 * @Date: 2022-12-14 17:06:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-20 18:45:37
 * @FilePath: \qpmn-site\src\app\modules\user\rest\partner\partner-rest-service.config.ts
 * @Description: 
 */
import { IRestfulConfigMap } from "@core/data-access/restful";
import { appConfig } from "@env/app-config";
import { envConfig } from "@env/env-config";

let PartnerRestServiceConfig: IRestfulConfigMap = {
    partnerRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取partner信息
            get: {
                method: "get",
                path: "/api/partnerInfo",
                testPath: "/api/partnerInfo"
            },
            // 获取eshopper信息
            eshopperInfo: {
                method: "get",
                path: "/api/shopOwnerInfo",
                testPath: "/api/shopOwnerInfo",
            },
            // 重新发送partner验证邮件
            sendmail: {
                method: "post",
                path: "/api/v2/partnerMails",
                testPath: "/api/v2/partnerMails"
            },
            // partner邮箱验证
            verify: {
                method: "get",
                path: "/partnerVerifyMail",
                testPath: "/partnerVerifyMail",
                paramDefaults: {
                    token: "@token"
                },
                isAuth: false
            },
            // 修改e-shopper信息
            updateEShopperInfo: {
                method: "put",
                path: "/api/shopOwnerInfo",
                testPath: "/api/shopOwnerInfo",
            },
            // 修改partner联系人信息
            updatePartnerInfo: {
                method: "put",
                path: "/api/partners/:id/contactInfo",
                testPath: "/api/partners/:id/contactInfo",
                paramDefaults: {
                    id: "@id"
                }
            },
            // 匿名重发邮件
            anonymousResendMail: {
                method: "post",
                path: "partnerMails/resend",
                isAuth: false
            }
        }
    }
}


export { PartnerRestServiceConfig };